import type { EventSourceMessage } from 'eventsource-parser';
import { throwEventError } from '#connection/connection.ts';
import type { TSseEvent } from './reader.types.ts';

const DEFAULT_EVENT = 'message';
const ERROR_EVENT = 'error';

export const toSseEvent = ({
  event = DEFAULT_EVENT,
  data,
  id,
}: EventSourceMessage): TSseEvent => {
  if (event === ERROR_EVENT) {
    throwEventError(data);
  }

  return id === undefined ? { event, data } : { event, data, id };
};
